export default __webpack_public_path__ + "0cf4d9821c6f62da6150ac162fe81f53.jpeg";